/**
 * Promise.allSettled isn't available in older browser impelmentations and
 * the feature isn't polyfilled for us. Therefore, when the functionality is missing
 * we implement it ourselves.
 */
Promise.allSettled =
    Promise.allSettled ||
    function (promises: any) {
        const mappedPromises = promises.map((p: any) => {
            return p
                .then((value: any) => {
                    return {
                        status: "fulfilled",
                        value,
                    };
                })
                .catch((reason: any) => {
                    return {
                        status: "rejected",
                        reason,
                    };
                });
        });
        return Promise.all(mappedPromises);
    };

// Safari 10 lacks support.
Promise.prototype.finally =
    Promise.prototype.finally ||
    function <T>(this: Promise<T>, callback: () => void) {
        return this.then(callback, callback);
    };

(window as any).global ||= window;
(window as any).process = { env: import.meta.env };

// Required so that this file isn't an isolated module.
export {};
